import type { DriverResponse } from '@contracts/driver/DriverResponse';
import { DriversClient } from '@src/driver/services/DriversClient';
import type { DriverInformationInputsSchema } from '@src/orders/schemas/DriverInformationInputsSchema';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type * as yup from 'yup';

interface Props {
  clientId: string;
  onSuccess: (newDriver: DriverResponse) => void;
}

export const useCreateDriver = ({ clientId, onSuccess }: Props) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: (data: yup.InferType<typeof DriverInformationInputsSchema>) =>
      DriversClient.create(clientId, {
        name: data.driverName!,
        email: data.driverEmail || undefined,
        phone: data.driverPhone || undefined,
        licenseNumber: data.driverLicenseNumber!,
      }),
    onSuccess: async (newDriver) => {
      onSuccess(newDriver);
      await queryClient.invalidateQueries({
        queryKey: ['drivers.list', clientId],
      });
    },
  });

  return {
    createDriver: mutate,
    isLoading: isPending,
  };
};
